"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _chunkE = require("./chunk-e8276423.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  flex-wrap: wrap;\n\n  width: 100%;\n  height: 100%;\n  padding: 20px 60px;\n\n  background-color: ", ";\n\n  &.whiteFallback {\n    background-color: white;\n\n    .cpanel {\n      box-shadow: ", "\n          0 0 0 1px,\n        ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PanelBG = function PanelBG(_ref) {
  var className = _ref.className,
      type = _ref.type,
      divProps = (0, _chunkB2edacfb.j)(_ref, ["className", "type"]);
  return _react.default.createElement(StyledBG, (0, _chunkB2edacfb.g)({}, divProps, {
    className: (0, _classnames.default)(className, type)
  }));
};

var StyledBG = _styledComponents.default.div.withConfig({
  displayName: "PanelBG__StyledBG",
  componentId: "sc-1907rjb-0"
})(_templateObject(), function (props) {
  return props.flexDirection;
}, function (props) {
  return props.alignItems;
}, function (props) {
  return props.justifyContent;
}, function (props) {
  return props.theme["$gray-1"];
}, function (props) {
  return (0, _chunkE.a)(0.92, props.theme["$blue-gray-1"]);
}, function (props) {
  return props.theme["$box-shadow-1"];
});

var PANEL_TYPES = {
  normal: "normal",
  whiteFallback: "whiteFallback"
};

var PanelBGType = _propTypes.default.oneOf(Object.values(PANEL_TYPES));

PanelBG.displayName = "CPanel.BG";
PanelBG.propTypes = {
  flexDirection: _propTypes.default.oneOf(["row", "column"]),
  justifyContent: _propTypes.default.string,
  alignItems: _propTypes.default.string,
  type: PanelBGType
};
PanelBG.defaultProps = {
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  type: "normal"
};
PanelBG.enums = {
  PanelBGType: PANEL_TYPES
};
PanelBG.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CPanel.BG",
  "props": {
    "flexDirection": {
      "defaultValue": {
        "value": "\"row\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"row\"",
          "computed": false
        }, {
          "value": "\"column\"",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "justifyContent": {
      "defaultValue": {
        "value": "\"center\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "alignItems": {
      "defaultValue": {
        "value": "\"center\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "defaultValue": {
        "value": "\"normal\"",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "PanelBGType"
      },
      "required": false,
      "description": ""
    }
  }
};
var _default = PanelBG;
exports.default = _default;
PanelBG.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CPanel.BG",
  "props": {
    "flexDirection": {
      "defaultValue": {
        "value": "\"row\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"row\"",
          "computed": false
        }, {
          "value": "\"column\"",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "justifyContent": {
      "defaultValue": {
        "value": "\"center\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "alignItems": {
      "defaultValue": {
        "value": "\"center\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "type": {
      "defaultValue": {
        "value": "\"normal\"",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "PanelBGType"
      },
      "required": false,
      "description": ""
    }
  }
};